var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center px-2 rounded-full shadow bg-white"},[_c('Avatar',{attrs:{"member":_vm.data}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.data.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }